<script lang="ts">
    import { _} from "svelte-i18n";
    import SomethingCloseableOnMap from "../SomethingCloseableOnMap.svelte";
    import type { SearchOnMapManager } from "./SearchOnMapManager";

    export let manager: SearchOnMapManager;
    export let open: boolean = true;
    export let collapsed: boolean = false;
    export let i18nPrefix: string = "";
    let searchString: string = "";
    let searchResults: { description: string, location: { lng: number, lat: number } }[] = [];

    $: {
        if (searchString.length <= 0) {
            searchResults = [];
        } else {
            manager.geocodeForward({
                string: searchString
            }).then(result => {
                searchResults = result;
            });
        }
    }

    const onSelect = (result: { location: { lng: number, lat: number } }) => {
        searchResults = [];
        searchString = "";
        manager.onZoomTo({ center: result.location, zoom: 12 });
        //collapsed = true;
    }

    const onToggle = () => {
        collapsed = !collapsed;
    }
</script>

<SomethingCloseableOnMap {open} class="search {collapsed ? 'collapsed' : ''}">
    <div class="input-group input-group-lg">
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <span class="input-group-text border-0 {collapsed ? 'collapsed' : ''}" on:click={onToggle}>
            <i class="fe fe-search" />
        </span>

        {#if !collapsed}
        <input
            type="text"
            class="form-control border-0 px-1"
            bind:value={searchString}
            aria-label="{$_(`${i18nPrefix}search.placeholder`)}"
            placeholder="{$_(`${i18nPrefix}search.placeholder`)}" />

        <span class="input-group-text border-0 py-0 ps-1 pe-3">
            <span
                class="h6 text-uppercase text-muted d-none d-md-block mb-0 me-5">

            </span>
        </span>
        {/if}
    </div>
    <div class="search-results rounded">
        <ul class="list-group px-0">
            {#each searchResults as result}
                <!-- svelte-ignore a11y-click-events-have-key-events -->
                <li class="list-group-item list-group-item-action" on:click={() => onSelect(result)}>{result.description}</li>
            {/each}
        </ul>
        
    </div>
</SomethingCloseableOnMap>

<style>

</style>